import { apiSlice } from "../apiSlice";

const districtApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getDistrictList: builder.query({
            query: () => {
                return {
                    url: `/api/admin/district/list`,
                    method: "GET",
                };
            },
            providesTags: ['districtList']
        }),
    }),
    overrideExisting: true,
});

export const { useGetDistrictListQuery } = districtApiSlice;
